const BlackBg = ({ cancel }) => {
  // cancel on click
  return (
    <div
      className="bg-black opacity-50 w-[100vw] h-[100vh] overflow-hidden absolute inset-0 z-10"
      onClick={cancel}
    />
  );
};

export default BlackBg;
